import { FiCopy } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";
import logo from "../images/pokedoa.png";
import { useTranslation } from "../hooks/useTranslation";
import { useWallet } from "../hooks/useWallet";
import LanguageSwitcher from "./LanguageSwitcher";
import IconAllInclusive from "../images/icon-all-inclusive.png";

export default function Header() {
    const { t } = useTranslation();
    const location = useLocation();
    const {
        account,
        isConnecting,
        connectWallet,
        disconnectWallet,
        copyAddress,
        freeStaking,
        isTokenPocketBlocked
    } = useWallet();

    // Mobile menu state removed

    return (
        <header className="relative flex items-center justify-between p-2 border-b border-gray-800 bg-gray-950">
            <div className="flex items-center space-x-4">
                {/* Logo */}
                <div className="flex w-full items-center justify-between space-x-2">
                    {/* Logo */}
                    <div className="flex items-center space-x-2 pr-4 md:pr-10">
                        <Link to="/dashboard">
                            <img
                                src={logo}
                                alt="crm"
                                className="w-40 sm:w-48 md:w-56 h-auto main-logo drop-shadow-md"
                            />
                        </Link>
                    </div>
                    {/* Desktop Navigation */}
                    <nav className="hidden md:flex space-x-6">
                        <Link
                            to="/dashboard"
                            className={`font-medium transition-all duration-200 ${location.pathname === "/dashboard"
                                ? "text-theme border-b-2 border-theme pb-1"
                                : "text-gray-50 hover:text-gray-500"
                                }`}
                        >
                            {t("dashboard.title")}
                        </Link>
                        <Link
                            to="/community"
                            className={`font-medium transition-all duration-200 ${location.pathname === "/community"
                                ? "text-theme border-b-2 border-theme pb-1"
                                : "text-gray-50 hover:text-gray-500"
                                }`}
                        >
                            {t("community.title")}
                        </Link>
                        <Link
                            to="/staking"
                            className={`font-medium transition-all duration-200 ${location.pathname === "/staking"
                                ? "text-theme border-b-2 border-theme pb-1"
                                : "text-gray-50 hover:text-gray-500"
                                }`}
                        >
                            {t("staking.title")}
                        </Link>
                        {/* <Link
                            to="/deposit"
                            className={`font-medium transition-all duration-200 ${location.pathname === "/deposit"
                                ? "text-theme border-b-2 border-theme pb-1"
                                : "text-gray-50 hover:text-gray-500"
                                }`}
                        >
                            {t("header.deposit")}
                        </Link> */}
                        <Link
                            to="/deposit-vt"
                            className={`font-medium transition-all duration-200 ${location.pathname === "/deposit-vt"
                                ? "text-theme border-b-2 border-theme pb-1"
                                : "text-gray-50 hover:text-gray-500"
                                }`}
                        >
                            VT {t("header.deposit")}
                        </Link>
                        <Link
                            to="/swap"
                            className={`font-medium transition-all duration-200 ${location.pathname === "/swap"
                                ? "text-theme border-b-2 border-theme pb-1"
                                : "text-gray-50 hover:text-gray-500"
                                }`}
                        >
                            {t("swap.title")}
                        </Link>
                        <Link
                            to="/income-report"
                            className={`font-medium transition-all duration-200 ${location.pathname === "/income-report"
                                ? "text-theme border-b-2 border-theme pb-1"
                                : "text-gray-50 hover:text-gray-500"
                                }`}
                        >
                            {t("incomeReport.title")}
                        </Link>
                        {freeStaking &&
                            <Link
                                to="/free-staking"
                                className={`font-medium transition-all duration-200 ${location.pathname === "/free-staking"
                                    ? "text-theme border-b-2 border-theme pb-1"
                                    : "text-gray-50 hover:text-gray-500"
                                    }`}
                            >
                                {t("freeStaking.title")}
                            </Link>
                        }
                        {/* <Link
                            to="/claim-reward"
                            className={`font-medium transition-all duration-200 ${location.pathname === "/claim-reward"
                                ? "text-theme border-b-2 border-theme pb-1"
                                : "text-gray-50 hover:text-gray-500"
                                }`}
                        >
                            {t("header.claimReward")}
                        </Link> */}
                        {/* <Link
                            to="/nft-details"
                            className={`font-medium transition-all duration-200 ${location.pathname === "/nft-details"
                                ? "text-theme border-b-2 border-theme pb-1"
                                : "text-gray-50 hover:text-gray-500"
                                }`}
                        >
                            NFT Details
                        </Link> */}
                        <Link
                            to="/history"
                            className={`font-medium transition-all duration-200 ${location.pathname === "/history"
                                ? "text-theme border-b-2 border-theme pb-1"
                                : "text-gray-50 hover:text-gray-500"
                                }`}
                        >
                            {t("general.history")}
                        </Link>
                    </nav>

                    {/* Mobile Navigation Toggle Button Removed */}
                </div>
            </div>

            <div className="flex items-center space-x-3">
                <LanguageSwitcher />
                {account && !isTokenPocketBlocked ? (
                    <div className="flex items-center space-x-2 bg-gray-100 rounded-lg px-3 py-1 break-all">
                        <div className="size-2 bg-green-500 rounded-full flex-shrink-0"></div>
                        <span className="text-sm text-xs font-medium text-gray-700 line-clamp-1">
                            {account.slice(0, 6)}...{account.slice(-4)}
                        </span>
                        <button
                            onClick={copyAddress}
                            className="text-gray-500 hover:text-gray-700"
                            title={t("header.copyAddress")}
                        >
                            <FiCopy className="size-4" />
                        </button>
                        <button
                            onClick={disconnectWallet}
                            className="text-gray-500 hover:text-red-600 ml-1"
                            title={t("header.disconnect")}
                        >
                            ×
                        </button>
                    </div>
                ) : !isTokenPocketBlocked ? (
                    <button
                        onClick={connectWallet}
                        disabled={isConnecting}
                        className="bg-[#111020] hover:bg-[#111020] text-white text-sm px-4 py-2 border border-[#9770DD]/30 rounded-lg font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
                    >
                        <img src={IconAllInclusive} alt="All Inclusive" className="size-5 mr-2" />
                        {isConnecting
                            ? t("common.loading")
                            : t("header.connectWallet")}
                    </button>
                ) : null}
            </div>

        </header >
    );
}